module.exports = __webpack_public_path__ + "assets/images/magenta_sport_4_league.c6e2fa462f3d51df602f0c2216bdeca3.png";